import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { AppContext } from 'lane-shared/contexts';
import ControlMenu from 'components/general/ControlMenu';

import stripeConnectButtonImage from 'static/img/stripe-connect-button.png';

import styles from './StripeConnectSetup.scss';

export default function StripeContinueOnboarding({ merchantAccount }: any) {
  const { t } = useTranslation();
  const { whitelabel } = useContext(AppContext);
  const whiteLabelName = whitelabel?.name;

  return (
    <div className={styles.StripeConnectSetup}>
      <div className={styles.message}>
        <h3>{t('web.admin.channel.merchantAccount.stripeContinueOnboarding.title')}</h3>
        <p>
          {t('web.admin.channel.merchantAccount.stripeContinueOnboarding.description')}
        </p>
        <ControlMenu>
          <a href={merchantAccount.onboardingLink.url} target="_self">
            <img
              className={styles.stripeButton}
              src={stripeConnectButtonImage}
              alt={t(
                'web.admin.channel.merchantAccount.stripeConnect.imageAlt',
                { whiteLabelName }
              )}
            />
          </a>
        </ControlMenu>
      </div>
    </div>
  );
}
